import { safeJsonParse } from '@dealstack/shared/lib/format/json';

export enum StorageKeys {
	PRODUCT_TOUR_HINT_1_KEY = 'PRODUCT_TOUR_HINT_1_KEY',
	SHOW_COUNTERPARTY_NAMES_KEY = 'SHOW_COUNTERPARTY_NAMES_KEY',
	UI_LANGUAGE_LIST = 'UI_LANGUAGE_LIST',
	CAP_TABLE_LOCAL_STORAGE_SETTINGS_KEY = 'CAP_TABLE_LOCAL_STORAGE_SETTINGS_KEY',
	CAP_CHART_LOCAL_STORAGE_SETTINGS_KEY = 'CAP_CHART_LOCAL_STORAGE_SETTINGS_KEY',
	CAP_SECURITIES_TABLE_COLS = 'CAP_SECURITIES_TABLE_COLS',
	CAP_TRANSACTIONS_TABLE_COLS = 'CAP_TRANSACTIONS_TABLE_COLS',
	CAP_OWNERSHIP_REGULAR_TABLE_COLS = 'CAP_OWNERSHIP_REGULAR_TABLE_COLS',
	CAP_HOLDINGS_TABLE_COLS = 'CAP_HOLDINGS_TABLE_COLS',
	VISITED_STEPS_STORAGE_KEY = 'VISITED_STEPS_STORAGE_KEY_mipId_',
	INVESTOR_HELP_PAGE_BACK_LINK_LOCAL_STORAGE_KEY = 'INVESTOR_HELP_PAGE_BACK_LINK_LOCAL_STORAGE_KEY',
	RWD_LOCAL_STORAGE_ENTRY = 'DID_SAW_RWD_ERROR_MODAL',
	DID_SAW_MIP_CREATE_HELP_ON_MIP = 'DID_SAW_MIP_CREATE_HELP_ON_MIP_',
	DID_APPLY_PROGRAMME_DEFAULTS_ON_MIP = 'DID_APPLY_PROGRAMME_DEFAULTS_ON_MIP_',
	TOKEN_LOCK_TIME_IN_Millis = 'TOKEN_LOCK_KEY',
	ENTITY_PIN_LOCALSTORAGE_KEY = 'ENTITY_PIN_LOCALSTORAGE_KEY_dealId_ ',
	MIP_MANAGE_INVESTMENTS_TABLE_COLS = 'MIP_MANAGE_INVESTMENTS_TABLE_COLS',
	MIP_MANAGE_INVESTORS_TABLE_COLS = 'MIP_MANAGE_INVESTORS_TABLE_COLS',
	MIP_INVESTMENT_DETAILS_ALLOCATIONS_VIEW = 'MIP_INVESTMENT_DETAILS_ALLOCATIONS_VIEW',
	MIP_INVESTMENT_DETAILS_DOCUMENTS_VIEW = 'MIP_INVESTMENT_DETAILS_DOCUMENTS_VIEW',
	MIP_PROGRAMME_EMAIL_TEMPLATES_VIEW = 'MIP_PROGRAMME_EMAIL_TEMPLATES_VIEW',
	MIP_INVESTOR_DETAILS_HOLDINGS_VIEW = 'MIP_INVESTOR_DETAILS_HOLDINGS_VIEW',
	MIP_INVESTOR_DETAILS_DOCUMENTS_VIEW = 'MIP_INVESTOR_DETAILS_DOCUMENTS_VIEW',
	DEAL_EMAIL_TEMPLATES_VIEW = 'DEAL_EMAIL_TEMPLATES_VIEW',
	MIP_INVESTMENT_VEHICLE_DETAILS_HOLDINGS_VIEW = 'MIP_INVESTMENT_VEHICLE_DETAILS_HOLDINGS_VIEW',
	MIP_INVESTMENT_VEHICLE_DETAILS_RELATED_PEOPLE_VIEW = 'MIP_INVESTMENT_VEHICLE_DETAILS_RELATED_PEOPLE_VIEW',
	MIP_INVESTMENT_VEHICLE_DETAILS_DOCUMENTS_VIEW = 'MIP_INVESTMENT_VEHICLE_DETAILS_DOCUMENTS_VIEW',
}

export type StorageKeyMap = Record<StorageKeys, string>;

export const getStorageKeys = (id?: string): StorageKeyMap => ({
	[StorageKeys.PRODUCT_TOUR_HINT_1_KEY]: `product-tour-hint-1-for-dealId-${id}`,
	[StorageKeys.CAP_TABLE_LOCAL_STORAGE_SETTINGS_KEY]: `CAP_TABLE_LOCAL_STORAGE_SETTINGS_${id}`,
	[StorageKeys.CAP_CHART_LOCAL_STORAGE_SETTINGS_KEY]: `CAP_CHART_LOCAL_STORAGE_SETTINGS_${id}`,
	[StorageKeys.CAP_SECURITIES_TABLE_COLS]: `CAP_SECURITIES_TABLE_COLS`,
	[StorageKeys.CAP_TRANSACTIONS_TABLE_COLS]: `CAP_TRANSACTIONS_TABLE_COLS`,
	[StorageKeys.CAP_OWNERSHIP_REGULAR_TABLE_COLS]: `CAP_OWNERSHIP_REGULAR_TABLE_COLS`,
	[StorageKeys.CAP_HOLDINGS_TABLE_COLS]: `CAP_HOLDINGS_TABLE_COLS`,
	[StorageKeys.SHOW_COUNTERPARTY_NAMES_KEY]: 'show_counterparty_names_key',
	[StorageKeys.UI_LANGUAGE_LIST]: 'ui_language_list',
	[StorageKeys.VISITED_STEPS_STORAGE_KEY]: `VISITED_STEPS_STORAGE_KEY_mipId_${id}`,
	[StorageKeys.INVESTOR_HELP_PAGE_BACK_LINK_LOCAL_STORAGE_KEY]:
		'investor_help_page_back_link_local_storage_key',
	[StorageKeys.RWD_LOCAL_STORAGE_ENTRY]: 'DID_SAW_RWD_ERROR_MODAL',
	[StorageKeys.DID_SAW_MIP_CREATE_HELP_ON_MIP]: `DID_SAW_MIP_CREATE_HELP_ON_MIP_${id}`,
	[StorageKeys.DID_APPLY_PROGRAMME_DEFAULTS_ON_MIP]: `DID_APPLY_PROGRAMME_DEFAULTS_ON_MIP_${id}`,
	[StorageKeys.TOKEN_LOCK_TIME_IN_Millis]: 'TOKEN_LOCK_KEY',
	[StorageKeys.ENTITY_PIN_LOCALSTORAGE_KEY]: `ENTITY_PIN_LOCALSTORAGE_KEY_dealId_${id}`,
	[StorageKeys.MIP_MANAGE_INVESTMENTS_TABLE_COLS]: `MIP_MANAGE_INVESTMENTS_TABLE_COLS`,
	[StorageKeys.MIP_MANAGE_INVESTORS_TABLE_COLS]: `MIP_MANAGE_INVESTORS_TABLE_COLS`,
	[StorageKeys.MIP_INVESTMENT_DETAILS_ALLOCATIONS_VIEW]: `MIP_INVESTMENT_DETAILS_ALLOCATIONS_VIEW`,
	[StorageKeys.MIP_INVESTMENT_DETAILS_DOCUMENTS_VIEW]: `MIP_INVESTMENT_DETAILS_DOCUMENTS_VIEW`,
	[StorageKeys.MIP_PROGRAMME_EMAIL_TEMPLATES_VIEW]: `MIP_PROGRAMME_EMAIL_TEMPLATES_VIEW`,
	[StorageKeys.MIP_INVESTOR_DETAILS_HOLDINGS_VIEW]: `MIP_INVESTOR_DETAILS_HOLDINGS_VIEW`,
	[StorageKeys.MIP_INVESTOR_DETAILS_DOCUMENTS_VIEW]: `MIP_INVESTOR_DETAILS_DOCUMENTS_VIEW`,
	[StorageKeys.DEAL_EMAIL_TEMPLATES_VIEW]: `DEAL_EMAIL_TEMPLATES_VIEW`,
	[StorageKeys.MIP_INVESTMENT_VEHICLE_DETAILS_HOLDINGS_VIEW]: `MIP_INVESTMENT_VEHICLE_DETAILS_HOLDINGS_VIEW`,
	[StorageKeys.MIP_INVESTMENT_VEHICLE_DETAILS_RELATED_PEOPLE_VIEW]: `MIP_INVESTMENT_VEHICLE_DETAILS_RELATED_PEOPLE_VIEW`,
	[StorageKeys.MIP_INVESTMENT_VEHICLE_DETAILS_DOCUMENTS_VIEW]: `MIP_INVESTMENT_VEHICLE_DETAILS_DOCUMENTS_VIEW`,
});

export class StorageUtilities {
	public static setItem(key: keyof StorageKeyMap, value: unknown, id?: string): void {
		const objectString = JSON.stringify(value);
		const keys = getStorageKeys(id);
		localStorage.setItem(keys[key], objectString);
	}

	public static getItem<T = string>(key: keyof StorageKeyMap, id?: string): T | null {
		const keys = getStorageKeys(id);
		const objectString = localStorage.getItem(keys[key]);
		if (!objectString) {
			return null;
		}
		const object = safeJsonParse<T>(objectString);

		if (object === 'true' || object === 'false') {
			return (object === 'true') as T;
		}

		return object;
	}

	public static removeItem(key: keyof StorageKeyMap, id?: string): void {
		const keys = getStorageKeys(id);
		localStorage.removeItem(keys[key]);
	}

	public static clear(): void {
		localStorage.clear();
	}
}
